import { render, staticRenderFns } from "./LinksPage.vue?vue&type=template&id=4a2957e1"
import script from "./LinksPage.vue?vue&type=script&lang=js"
export * from "./LinksPage.vue?vue&type=script&lang=js"
import style0 from "./LinksPage.vue?vue&type=style&index=0&id=4a2957e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_babel-core@7.0.0-bridge.0_@babel+core@7.25.8__cac_7uvw3tio4x4egbur7wz2ifovwa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports